import { useSort } from '@/common/hooks/useSort';
import { getStockFromSearchParams } from '@/common/utils/pathHelper';
import FilterHeader from '@/components/FilterHeader';
import FilterModal from '@/components/FilterModal';
import CurrentFilters from '@/components/FilterModal/CurrentFilters';
import { fullPageLoadingIndicator } from '@/components/LoadingIndicator';
import ProductSort from '@/components/ProductSort';
import { Switch } from '@/components/ui/switch';
import { useAppContext } from '@/context/app';
import { useFilterSidebar } from '@/hooks/FilterSidebar';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useCallback, useRef, useState } from 'react';
import Button from '../Button';
import { useGetFilterData } from './use-get-filter-data';
export const CategoryFilterContainer = ({
  categoryId,
  categoryName,
  aggregations,
  sortFields,
  totalCount,
  currentCurrencyCode,
  categoryUrlKey,
  filters: filtersCondition,
  initialSortState,
  initialFiltersAggregations,
}: {
  categoryId: string;
  categoryName: string;
  aggregations: any;
  sortFields: any;
  totalCount: number;
  currentCurrencyCode: string;
  categoryUrlKey: string;
  filters: any;
  initialSortState?: any;
  initialFiltersAggregations?: any;
}) => {
  const { isMobile } = useIsMobile();
  const [{ drawer, isFilterSticky }, { toggleDrawer, closeDrawer }] = useAppContext();
  const DRAWER_NAME = 'filter';
  const isOpen = drawer === DRAWER_NAME;
  const searchParams = useSearchParams();
  const [stockStatus, setstockStatus] = useState(getStockFromSearchParams(searchParams));
  const isStock = Number(stockStatus) === 1;
  const handleOpen = useCallback(() => {
    toggleDrawer(DRAWER_NAME);
  }, [toggleDrawer]);
  const handleClose = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);
  const pathname = usePathname();

  const { filters, shouldShowFilterButtons, shouldShowFilterShimmer, filterLoading } = useGetFilterData({
    categoryId: categoryId,
    filtersCondition: filtersCondition,
    initialData: initialFiltersAggregations,
  });
  const availableSortMethods = sortFields || null;
  const sortLoading = false;
  const [sortStateFromUrl, sortApi] = useSort();
  const sortState = initialSortState || sortStateFromUrl;

  const handleSwitchChange = checked => {
    setstockStatus(checked);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('stock', checked ? '1' : '0');
    globalThis.location.href = `${pathname}?${searchParams.toString()}`;
  };
  const filterRef = useRef();
  const talonProps = useFilterSidebar({
    filters: filters || [],
    aggregations,
    sortFields,
  });
  const {
    filterApi,
    filterItems,
    filterNames,
    filterFrontendInput,
    filterState,
    handleApply,
    handleReset,
    handleGenerateLinkHref,
  } = talonProps;
  if (filterLoading || sortLoading) {
    return <>{fullPageLoadingIndicator}</>;
  }
  if (isMobile) {
    return (
      <>
        <div
          className={cn(
            'pb-[10px] text-center text-[18px] text-primary',
            isFilterSticky ? '' : 'mb-[20px] border-b border-solid border-[#e0e0e0] ',
          )}
          style={{ paddingBottom: filterState?.size === 0 ? '20px' : '' }}
        >
          <div className=' flex w-full justify-between'>
            <Button
              className={cn('h-[40px] w-[158px] rounded-[20px] border-none bg-[#F9F9F9]')}
              onClick={handleOpen}
            >
              <span className={cn('mr-[3px] font-roboto-regular text-[16px] font-black font-normal leading-[40px]')}>
                Filter & Sort
              </span>
              <Image
                src={`/icons/filter.svg`}
                width={22}
                height={22}
                alt='Filter icon'
                title='Filter products'
              />
            </Button>
            <div className={cn('flex items-center justify-center ')}>
              <Switch
                checked={isStock}
                onCheckedChange={handleSwitchChange}
                style={{ transform: 'scale(0.85)', transformOrigin: 'left center' }}
              />
              <span className={cn('ml-[10px] font-roboto-regular text-[16px] font-black font-normal')}>In Stock</span>
            </div>
          </div>
          {filters && filterState && filterState?.size != 0 && (
            <CurrentFilters
              filterApi={filterApi}
              filterNames={filterNames}
              filterState={filterState}
              onRemove={handleApply}
              clearAll={handleReset}
              isResearch
              classes={{
                root: 'py-0 overflow-auto mt-[24px] px-0 pb-[30px] border-none flex flex-col items-start relative',
              }}
            />
          )}

          {/* <div className=''>
            <ProductSort
              sortState={sortState}
              sortApi={sortApi}
              availableSortMethods={availableSortMethods}
            />
          </div>
          <div
            className={cn('flex items-center justify-center')}
            onClick={handleOpen}
          >
            <img
              src={filterIcon.src}
              className={'w-[18px]s h-[18px]'}
              alt='filter'
            />
            <span className=' border-r-1  border-solid border-[#ccc]  pl-[3px] pr-[20px] font-oswald-bold text-[12px] uppercase text-primary'>
              Filters
            </span>
            <img
              src={filterIcon2.src}
              className={'ml-5 h-[18px] w-[18px]'}
              alt='filter'
            />
          </div> */}
        </div>

        <div className={cn('!lg_hidden flex flex-col', isOpen ? 'mb-4' : '')}>
          <Suspense fallback={null}>
            <FilterModal
              categoryId={categoryId}
              filters={filters}
              aggregations={aggregations}
              sortFields={sortFields}
              totalCount={totalCount}
              currentCurrencyCode={currentCurrencyCode}
              categoryUrlKey={categoryUrlKey}
              categoryName={categoryName}
              handleClose={handleClose}
              handleOpen={handleOpen}
              isOpen={isOpen}
              shouldShowFilterButtons={shouldShowFilterButtons}
              sortState={sortState}
              sortApi={sortApi}
              availableSortMethods={availableSortMethods}
              handleGenerateLinkHref={handleGenerateLinkHref}
            />
          </Suspense>
        </div>
      </>
    );
  }

  return (
    <div className={cn('relative w-full border-b border-solid border-[#e0e0e0] pb-[20px]')}>
      {filters && (
        <FilterHeader
          filters={filters}
          aggregations={aggregations}
          sortFields={sortFields}
          shouldShowFilterShimmer={shouldShowFilterShimmer}
          handleGenerateLinkHref={handleGenerateLinkHref}
        />
      )}
      <div className={cn('absolute right-0 top-0 flex items-center justify-center bg-white')}>
        <Switch
          checked={isStock}
          onCheckedChange={handleSwitchChange}
        />
        <span className={cn('ml-[10px] font-roboto-regular text-[18px] font-black font-normal')}>In Stock</span>
        <ProductSort
          sortState={sortState}
          sortApi={sortApi}
          availableSortMethods={availableSortMethods}
        />
      </div>
    </div>
  );
};
